import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { SUBTITLES_DEFAULT_SIZES } from '../../../components/subtitles/constants';
import { SubtitlesDevice, SubtitlesPositions, SubtitlesTextSize } from '../../../components/subtitles/types';
import { fetchPlayerConfigAction } from '../../apiActions/fetchPlayerConfigAction';

import type { SubtitlesMessage } from './types';
import { SubtitlesGroup, SubtitlesState } from './types';

const initialState: SubtitlesState = {
  group: SubtitlesGroup.GROUP1,
  isEnabled: true,
  isOnboarded: false,
  sizes: SUBTITLES_DEFAULT_SIZES,
  positionsRaw: {},
  subtitle: {
    text: '',
  },
};

export const subtitlesSlice = createSlice({
  name: 'subtitles',
  initialState,
  reducers: {
    finishOnboarding: (state) => {
      state.isOnboarded = true;
    },
    setGroup: (state, action: PayloadAction<SubtitlesGroup>) => {
      state.group = action.payload;
    },
    setIsEnabled: (state, action: PayloadAction<boolean>) => {
      state.isEnabled = action.payload;
    },
    setSize: (state, action: PayloadAction<{ deviceType: SubtitlesDevice; size: SubtitlesTextSize }>) => {
      state.sizes[action.payload.deviceType] = action.payload.size;
    },
    setSubtitle: (state, action: PayloadAction<SubtitlesMessage>) => {
      state.subtitle = {
        text: action.payload.content,
        isFinal: action.payload.isFinal,
      };
    },
    setPositions: (state, action: PayloadAction<{ gameType: string; positions: SubtitlesPositions }>) => {
      state.positionsRaw[action.payload.gameType] = action.payload.positions;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPlayerConfigAction.fulfilled, (state, action) => {
      state.isEnabled = action.payload.subtitlesEnabled[state.group];
      state.isOnboarded = action.payload.subtitlesOnboarded;

      if (action.payload.subtitlesSize) {
        const size = action.payload.subtitlesSize;
        try {
          state.sizes = JSON.parse(size);
        } catch (e) {
          //
        }
      }

      if (action.payload.subtitlesPositionsRaw) {
        state.positionsRaw = JSON.parse(action.payload.subtitlesPositionsRaw);
      }
    });
  },
});

export const subtitlesActions = subtitlesSlice.actions;
